import { NotificationOutlined } from '@ant-design/icons';
import { type NodeProps } from '@xyflow/react';
import SendWebengageEventContent from 'automations/components/Nodes/SendWebengageEventContent';
import { type SendWebengageEventNodeType } from 'automations/types/nodeSchemas/actionNodes';
import { nodeSchemas } from 'automations/types/nodeTypes';
import { getErrorList } from 'automations/utils/zod';
import { useMemo } from 'react';

import { type ActionNodeReturnProps } from './useActionNodeConfig';

export default function useSendWebengageEvent(
  node: NodeProps<SendWebengageEventNodeType>,
): ActionNodeReturnProps {
  const errorMessages = useMemo(
    () => getErrorList(nodeSchemas.SendWebengageEventActionNodeData, node.data),
    [node.data],
  );
  const AdditionalUI = useMemo(() => <SendWebengageEventContent node={node} />, [node]);

  const subTitle = useMemo(
    () => node.data?.additionalOptions?.sendWebengageEvent?.eventName,
    [node.data?.additionalOptions?.sendWebengageEvent?.eventName],
  );

  return {
    subTitle,
    icon: NotificationOutlined,
    hasErrors: errorMessages.length > 0,
    errorMessages,
    AdditionalUI,
  };
}
